import React, { useState } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Modal,
} from '@lockerpm/design';

import formsComponents from "../../../../../../components/forms";

import userServices from '../../../../../../services/user';
import authServices from '../../../../../../services/auth';

import global from "../../../../../../config/global";

const ChangePasswordModal = (props) => {
  const { ChangePassword } = formsComponents;
  const { t } = useTranslation()
  const {
    visible = false,
    currentPassword = null,
    onClose = () => { },
  } = props;
  
  const userInfo = useSelector((state) => state.auth.userInfo);
  const [callingAPI, setCallingAPI] = useState(false);

  const handleSave = async (values) => {
    setCallingAPI(true);
    await userServices.change_password({
      username: userInfo.email,
      password_hint: values.password_hint || undefined,
      login_method: 'password',
      password: currentPassword,
      kdf: userInfo.kdf,
      kdf_iterations: userInfo.kdf_iterations,
      kdf_memory: userInfo.kdf_memory,
      kdf_parallelism: userInfo.kdf_parallelism,
    }, {
      password: values.new_password,
      kdf: userInfo.kdf,
      kdf_iterations: userInfo.kdf_iterations,
      kdf_memory: userInfo.kdf_memory,
      kdf_parallelism: userInfo.kdf_parallelism,
    }).then(async () => {
      global.pushSuccess(t('notification.success.change_password.changed'));
      onClose();
      authServices.logout(true);
    }).catch((error) => {
      global.pushError(error)
    })
    setCallingAPI(false);
  }

  return (
    <Modal
      title={t('change_password.title')}
      open={visible}
      onCancel={onClose}
      width={360}
      footer={false}
    >
      <ChangePassword
        changing={callingAPI}
        isReset={false}
        onSave={(values) => handleSave(values)}
      />
    </Modal>
  );
}

export default ChangePasswordModal;